import { normalize, removeSpaces } from "../../../utils/typeUtils"

export const standarize = (value: string) => normalize(removeSpaces(value.toLowerCase()))
